import React from "react"
import { useSelector } from "react-redux"
import { triangleAlert } from "components/Icons";
import {
  REGISTERED_SURVEYORS_USER,
  DRAFTING_USER,
  DRAFTING_OVERSEAS,
  DRAFTING_OVERSEAS_PHILIPPINES,
  DRAFTING_OVERSEAS_LEBANON,
  SURVEYORS,
  ACCESS_CONTACT_TYPE
} from "../../../../utils/constants"
import { getCurrentUser } from "../../reducers";

const ContactListItem = ({ contact, limitedInfo, isDraftingOverseas }) => {
  const {
    attributes: {
      firstName, lastName, email, phoneNumber, clientType, contactType, contactTypeObject,
      contactMarkedAs
    }
  } = contact
  const isAccessContact = contactMarkedAs === ACCESS_CONTACT_TYPE
  const currentUser = useSelector(getCurrentUser)
  const defaultRole = currentUser.attributes.default_role
  const limitedRoles = [REGISTERED_SURVEYORS_USER, DRAFTING_USER, DRAFTING_OVERSEAS, DRAFTING_OVERSEAS_PHILIPPINES, DRAFTING_OVERSEAS_LEBANON, SURVEYORS]

  return isDraftingOverseas && !["person", "invoice"].includes(contactTypeObject.value) ? (
    <></>
  ) : (
    <div className="d-flex align-items-start contact-item">
      <img
        className="mr-3"
        src="/assets/icons/icn_contact_user-fe25297bee5a727ac1f4f052d0a0ad53bb7b3d8c02ce3ae3857592f83f1665e3.svg" />

      <div className="contact-info">
        <div className="d-flex align-items-center">
          <span>{`${firstName} ${lastName} (${contactTypeObject.label})`}</span>
          { contactType === "account_payable" && <span className="badge badge-dark ml-2">Account Payable</span> }
        </div>

        { !isDraftingOverseas && phoneNumber && (
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        )}
        {(!limitedInfo || !limitedRoles.includes(defaultRole)) && email && (
          <>
            <span className="ml-1">&middot;</span>
            <a className="ml-1" href={`mailto:${email}`}>Email</a>
          </>
        )}
        {isAccessContact && (
          <>
            <br />
            <span className="d-inline-block">
              <div className="d-flex align-items-center">
                <div className={`font-075rem px-2 bg-${phoneNumber ? "green" : "red"} text-white text-center`}>
                  Access Contact
                </div>
                { !phoneNumber && (
                  <span className="ml-1 d-flex align-items-center justify-content-center" data-toggle="tooltip" title={`This person will not receive Tracking as there is no Mobile Number!`}>
                    <img src={triangleAlert} className="icon-size-15" id="access-contact-no-mobile" />
                  </span>
                )}
              </div>
            </span>
          </>
        )}

        <br />
        { !isDraftingOverseas && <span>{clientType}</span> }
      </div>
    </div>
  )
}

export default ContactListItem
